<app-rectangle-simmer *ngIf="simmerStatus"></app-rectangle-simmer>
<section
  class="multi-slider top-rated-user-sect gray-bg"
  *ngIf="!simmerStatus && partnerData.length > 0"
>
  <div class="content-slider content-padding">
    <div class="content-box">
      <div class="">
        <h1 class="mb-3 slider-heading">
          {{ content }}
        </h1>
        <!-- <p class="text-secondary">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam
          volutpat est in magna lacinia, at efficitur justo laoreet.
        </p> -->
        <hr />
        <a
          [routerLink]="['/partner-list']"
          class="text-secondary d-flex align-items-center"
        >
          {{ "HOME.VIEW_ALL" | translate }}
          <span class="mdi mdi-chevron-right font-18 ml-1"></span>
        </a>
      </div>
    </div>
    <div class="">
      <div id="slider-top patner-slid" *ngIf="carouselStatus">
        <owl-carousel-o [options]="toprated" checkVisibility="true">
          <ng-container *ngFor="let watch of partnerData; let i = index">
            <ng-template carouselSlide [id]="watch.public_id">
              <div class="series-box">
                <app-grid
                  [data]="watch"
                  [gridType]="'square'"
                  [type]="'partner_home'"
                ></app-grid>
              </div>
            </ng-template>
          </ng-container>
        </owl-carousel-o>
      </div>
    </div>
  </div>
</section>
